import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, isRef as _isRef, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = {
  key: 0,
  class: "ctx-modelo"
}
const _hoisted_4 = {
  key: 1,
  class: "subtitulo"
}
const _hoisted_5 = {
  key: 0,
  class: "info"
}
const _hoisted_6 = {
  key: 1,
  class: "selector-tipo"
}
const _hoisted_7 = { class: "ayuda" }
const _hoisted_8 = { class: "tipos" }
const _hoisted_9 = ["value", "disabled"]
const _hoisted_10 = { class: "tipo-nombre" }
const _hoisted_11 = { class: "tipo-detalle" }
const _hoisted_12 = { class: "botones-generar" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "barra-estado" }
const _hoisted_15 = { class: "barra-izq" }
const _hoisted_16 = { class: "progreso-texto" }
const _hoisted_17 = { class: "barra-der" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "arbol"
}
const _hoisted_20 = { class: "arbol-head" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "check" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "check" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "check" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "edit-titulo" }
const _hoisted_29 = { class: "edit-ctrl" }
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = ["disabled", "onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "nueva-sec-form" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "edit-factor-label" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "edit-titulo" }
const _hoisted_38 = { class: "edit-ctrl" }
const _hoisted_39 = ["disabled", "onClick"]
const _hoisted_40 = ["disabled", "onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "nueva-sec-form sub"
}
const _hoisted_43 = ["onKeyup"]
const _hoisted_44 = ["disabled", "onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "editor-panel" }
const _hoisted_47 = {
  key: 0,
  class: "tabs"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 1,
  class: "contexto"
}
const _hoisted_50 = { class: "bloques-area" }
const _hoisted_51 = { class: "bloques-header" }
const _hoisted_52 = {
  key: 0,
  class: "bloques-lista"
}
const _hoisted_53 = { class: "bloque-controles" }
const _hoisted_54 = { class: "bloque-tipo-label" }
const _hoisted_55 = { class: "bloque-acciones" }
const _hoisted_56 = ["disabled", "onClick"]
const _hoisted_57 = ["disabled", "onClick"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = {
  key: 0,
  class: "bloque-editor-inline"
}
const _hoisted_63 = { class: "editor-pie" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  key: 0,
  class: "bloque-colapsado-label"
}
const _hoisted_67 = {
  key: 1,
  class: "bloques-vacio"
}
const _hoisted_68 = ["innerHTML"]
const _hoisted_69 = { class: "editor-pie" }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = {
  key: 1,
  class: "vacio"
}

import { ref, computed, reactive, onMounted, nextTick, watch } from 'vue'
import { useRoute } from 'vue-router'
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import {
  getTiposInformeService, generarInformeService, getInformeService,
  actualizarInformeService, guardarRedaccionService, avalarInformeService,
  type Informe, type TipoInforme, type RedaccionInforme
} from '@/services/InformeService'
import { getProcesoByIdService, getTiposEjecucionModeloService } from '@/services/ProcesoAutoevaluacionService'
import { useGestionResultadosAutoevaluacion } from '@/store/GestionResultadosAutoevaluacion'
import BloqueDatos from '@/components/BloqueDatos.vue'
import CatalogoBloquesModal from '@/components/CatalogoBloquesModal.vue'
import ConfiguradorBloqueModal from '@/components/ConfiguradorBloqueModal.vue'
import VistaPreviewInforme from '@/components/VistaPreviewInforme.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'

interface BloqueDesc { id: string; tipo: string; params?: Record<string, any> }
interface NodoArbol { id: number; nombre: string; hijos: Array<{ id: number; nombre: string }> }

interface SeccionItem {
  id: string
  tipo: 'default' | 'libre'
  campo?: string
  titulo: string
  visible: boolean
}

interface SubSeccionItem {
  clave: string
  titulo: string
  visible: boolean
  libre: boolean
}

interface EstructuraInforme {
  secciones: SeccionItem[]
  factoresSubs: Record<string, SubSeccionItem[]>
}

type Seleccion =
  | { tipo: 'general'; campo: string }
  | { tipo: 'libre'; id: string }
  | { tipo: 'componente'; id: number; nivel: 'factor' | 'caracteristica' }


export default /*@__PURE__*/_defineComponent({
  __name: 'InformeAutoevaluacionView',
  setup(__props) {

/**
 * Redacción del informe de autoevaluación.
 *
 * Editor enriquecido por componente y exportación a PDF. El estado `avalado` es
 * el que habilita la radicación.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/ejecucion/:id_ejecucion/informe` (InformeAutoevaluacion) — permiso `informes.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const idEjecucion = Number(route.params.id_ejecucion)


const SECCIONES_DEFAULT: SeccionItem[] = [
  { id: 'gen-presentacion',         tipo: 'default',      campo: 'presentacion',         titulo: 'Presentación',             visible: true },
  { id: 'gen-descripcion_programa', tipo: 'default',      campo: 'descripcion_programa', titulo: 'Descripción del programa', visible: true },
  { id: 'gen-analisis_resultados',  tipo: 'default',      campo: 'analisis_resultados',  titulo: 'Análisis de resultados',   visible: true },
  { id: 'gen-conclusion',           tipo: 'default',      campo: 'conclusion',           titulo: 'Conclusión',               visible: true },
]

const SUBSECCIONES_DEFAULT: SubSeccionItem[] = [
  { clave: 'conclusiones',             titulo: 'Conclusiones',          visible: true, libre: false },
  { clave: 'fortalezas_edit',          titulo: 'Fortalezas',            visible: true, libre: false },
  { clave: 'debilidades_edit',         titulo: 'Debilidades',           visible: true, libre: false },
  { clave: 'acciones_fortalecimiento', titulo: 'Acc. fortalecimiento',  visible: true, libre: false },
  { clave: 'acciones_mejoramiento',    titulo: 'Acc. mejoramiento',     visible: true, libre: false },
  { clave: 'anexos',                   titulo: 'Anexos',                visible: true, libre: false },
]

const resultadosStore = useGestionResultadosAutoevaluacion()
const mostrarCatalogo    = ref(false)
const mostrarPreview     = ref(false)
const imprimirAlAbrir    = ref(false)
const wordAlAbrir        = ref(false)
const bloqueConfigurando = ref<BloqueDesc | null>(null)
const bloquesActuales    = ref<BloqueDesc[]>([])
const bloquesColapsados  = ref<string[]>([])
const bloqueEditandoId   = ref<string | null>(null)
const cargando     = ref(true)
const generando    = ref(false)
const guardando    = ref(false)
const avalando     = ref(false)
const msj = reactive({ visible: false, mensaje: '', tipo: 'positivo' as 'positivo' | 'error' })
const tipos              = ref<TipoInforme[]>([])
const tipoSeleccionado   = ref<number | null>(null)
const tipoAutoDetectado  = ref(false)
const nombreVersion    = ref('')
const informe          = ref<Informe | null>(null)
const factores         = ref<NodoArbol[]>([])
const seleccion    = ref<Seleccion | null>(null)
const bloqueActivo = ref('conclusiones')
const editorEl     = ref<HTMLElement | null>(null)
let inlineEditorEl: HTMLElement | null = null
let quillMountedOn: HTMLElement | null = null
let quill: Quill | null = null

function toast(msg: string, tipo: 'positivo' | 'error' = 'positivo'): void {
  msj.mensaje = msg
  msj.tipo = tipo
  msj.visible = true
}

function toggleColapsarBloque(id: string): void {
  if (bloquesColapsados.value.includes(id)) {
    bloquesColapsados.value = bloquesColapsados.value.filter(x => x !== id)
  } else {
    bloquesColapsados.value = [...bloquesColapsados.value, id]
  }
}
const arbolVisible        = ref(true)
const modoEdicionArbol    = ref(false)
const estructura          = ref<EstructuraInforme>({ secciones: SECCIONES_DEFAULT.map(s => ({ ...s })), factoresSubs: {} })
const nuevaSeccionTitulo  = ref('')
const nuevaSubSeccionTitulo = ref('')
const factorEditandoId    = ref<number | null>(null)

function claveEstructura(): string {
  return `informe-estructura-${informe.value!.id_informe}`
}

function cargarEstructura(): void {
  if (!informe.value) return
  try {
    const raw = localStorage.getItem(claveEstructura())
    if (raw) {
      const parsed = JSON.parse(raw) as EstructuraInforme
      // Asegurar que las secciones por defecto existen si se añadieron nuevas en el código
      const ids = new Set(parsed.secciones.map(s => s.id))
      for (const def of SECCIONES_DEFAULT) {
        if (!ids.has(def.id)) parsed.secciones.push({ ...def })
      }
      estructura.value = parsed
    } else {
      estructura.value = { secciones: SECCIONES_DEFAULT.map(s => ({ ...s })), factoresSubs: {} }
    }
  } catch {
    estructura.value = { secciones: SECCIONES_DEFAULT.map(s => ({ ...s })), factoresSubs: {} }
  }
}

function persistirEstructura(): void {
  if (!informe.value) return
  localStorage.setItem(claveEstructura(), JSON.stringify(estructura.value))
}

// Computeds de estructura 

const seccionesVisibles = computed<SeccionItem[]>(() =>
  estructura.value.secciones.filter(s => s.visible)
)

function subSeccionesDeFactorTodas(factorId: number): SubSeccionItem[] {
  return estructura.value.factoresSubs[String(factorId)]
    ?? SUBSECCIONES_DEFAULT.map(s => ({ ...s }))
}

function subSeccionesDeFactorVisibles(factorId: number): SubSeccionItem[] {
  return subSeccionesDeFactorTodas(factorId).filter(s => s.visible)
}

// Operaciones de estructura 

function toggleVisibilidadSeccion(id: string): void {
  const s = estructura.value.secciones.find(x => x.id === id)
  if (s) { s.visible = !s.visible; persistirEstructura() }
}

function moverSeccion(id: string, dir: -1 | 1): void {
  const arr = estructura.value.secciones
  const idx = arr.findIndex(s => s.id === id)
  const nIdx = idx + dir
  if (nIdx < 0 || nIdx >= arr.length) return
  ;[arr[idx], arr[nIdx]] = [arr[nIdx], arr[idx]]
  persistirEstructura()
}

function agregarSeccionLibre(): void {
  const titulo = nuevaSeccionTitulo.value.trim()
  if (!titulo) return
  estructura.value.secciones.push({ id: `gen-libre-${crypto.randomUUID()}`, tipo: 'libre', titulo, visible: true })
  nuevaSeccionTitulo.value = ''
  persistirEstructura()
}

function eliminarSeccionLibre(id: string): void {
  estructura.value.secciones = estructura.value.secciones.filter(s => s.id !== id)
  if (seleccion.value?.tipo === 'libre' && (seleccion.value as any).id === id) seleccion.value = null
  persistirEstructura()
}

function toggleVisibilidadSubSeccion(factorId: number, clave: string): void {
  const subs = subSeccionesDeFactorTodas(factorId).map(s => ({ ...s }))
  const s = subs.find(x => x.clave === clave)
  if (s) {
    s.visible = !s.visible
    estructura.value.factoresSubs[String(factorId)] = subs
    persistirEstructura()
  }
}

function moverSubSeccion(factorId: number, clave: string, dir: -1 | 1): void {
  const subs = subSeccionesDeFactorTodas(factorId).map(s => ({ ...s }))
  const idx = subs.findIndex(s => s.clave === clave)
  const nIdx = idx + dir
  if (nIdx < 0 || nIdx >= subs.length) return
  ;[subs[idx], subs[nIdx]] = [subs[nIdx], subs[idx]]
  estructura.value.factoresSubs[String(factorId)] = subs
  persistirEstructura()
}

function agregarSubSeccionLibre(factorId: number): void {
  const titulo = nuevaSubSeccionTitulo.value.trim()
  if (!titulo) return
  const subs = subSeccionesDeFactorTodas(factorId).map(s => ({ ...s }))
  subs.push({ clave: `libre-${crypto.randomUUID()}`, titulo, visible: true, libre: true })
  estructura.value.factoresSubs[String(factorId)] = subs
  nuevaSubSeccionTitulo.value = ''
  factorEditandoId.value = null
  persistirEstructura()
}

function eliminarSubSeccionLibre(factorId: number, clave: string): void {
  const subs = subSeccionesDeFactorTodas(factorId).filter(s => s.clave !== clave)
  estructura.value.factoresSubs[String(factorId)] = subs
  persistirEstructura()
}

// Texto libre (localStorage) 

function claveTextoLibre(sectionId: string): string {
  return `informe-texto-libre-${informe.value!.id_informe}-${sectionId}`
}

function getTextoLibre(sectionId: string): string | null {
  try { return localStorage.getItem(claveTextoLibre(sectionId)) } catch { return null }
}

function setTextoLibre(sectionId: string, html: string | null): void {
  if (html) localStorage.setItem(claveTextoLibre(sectionId), html)
  else localStorage.removeItem(claveTextoLibre(sectionId))
}

function esBloqueLibre(factorId: number, clave: string): boolean {
  return subSeccionesDeFactorTodas(factorId).find(s => s.clave === clave)?.libre ?? false
}

function tieneContenidoLibre(id: string): boolean {
  if (!informe.value) return false
  try {
    if (localStorage.getItem(claveTextoLibre(id))) return true
    const raw = localStorage.getItem(storageKey(id))
    return raw ? (JSON.parse(raw) as any[]).length > 0 : false
  } catch { return false }
}

//  Selección e indicadores 

function esSeccionActiva(s: SeccionItem): boolean {
  const sel = seleccion.value
  if (!sel) return false
  if (s.tipo === 'default' && sel.tipo === 'general') return (sel as any).campo === s.campo
  if (s.tipo === 'libre' && sel.tipo === 'libre') return (sel as any).id === s.id
  return false
}

function tieneContenidoSeccion(s: SeccionItem): boolean {
  if (!informe.value) return false
  if (s.tipo === 'default' && s.campo) return !!(informe.value as any)[s.campo]
  return tieneContenidoLibre(s.id)
}

function seleccionarSeccion(s: SeccionItem): void {
  if (s.tipo === 'default' && s.campo) {
    seleccion.value = { tipo: 'general', campo: s.campo }
  } else {
    seleccion.value = { tipo: 'libre', id: s.id }
  }
  montarEditor()
}

//  Redacciones e indicadores de completitud 

const avalado = computed(() => informe.value?.estado === 'avalado')
const etiquetaEstado = computed(() =>
  ({ borrador: 'Borrador', en_revision: 'En revisión', avalado: 'Avalado' }[informe.value?.estado ?? 'borrador'])
)

const obligatorios = computed(() =>
  (informe.value?.redacciones ?? []).filter(r => ['analisis', 'conclusiones'].includes(r.bloque)).length
)
const redactados = computed(() =>
  (informe.value?.redacciones ?? []).filter(r => ['analisis', 'conclusiones'].includes(r.bloque) && r.contenido).length
)

function redaccion(idComponente: number, bloque: string): RedaccionInforme | undefined {
  return informe.value?.redacciones?.find(r => r.id_componente === idComponente && r.bloque === bloque)
}

function factorCompleto(idFactor: number): boolean {
  return !!redaccion(idFactor, 'conclusiones')?.contenido
}

const contexto = computed(() => {
  const s = seleccion.value
  if (!s || s.tipo === 'general' || s.tipo === 'libre') return ''
  for (const f of factores.value) {
    if (f.id === s.id) return `${f.nombre} — bloques de cierre del factor`
    const c = f.hijos.find(h => h.id === s.id)
    if (c) return `${f.nombre} → ${c.nombre} — análisis de la característica`
  }
  return ''
})

const contenidoActual = computed(() => {
  const s = seleccion.value
  if (!s || !informe.value) return null
  if (s.tipo === 'general') return (informe.value as any)[s.campo] as string | null
  if (s.tipo === 'libre') return getTextoLibre(s.id)
  const bloque = s.nivel === 'factor' ? bloqueActivo.value : 'analisis'
  if (s.nivel === 'factor' && esBloqueLibre(s.id, bloque)) return getTextoLibre(`comp-${s.id}-${bloque}`)
  return redaccion(s.id, bloque)?.contenido ?? null
})

// Editor Quill 

async function montarEditor(): Promise<void> {
  if (avalado.value) return
  await nextTick()
  const targetEl = bloqueEditandoId.value ? inlineEditorEl : editorEl.value
  if (!targetEl) return
  if (quill && quillMountedOn !== targetEl) {
    quill = null
    quillMountedOn = null
  }
  if (!quill) {
    quill = new Quill(targetEl, {
      theme: 'snow',
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ header: [3, 4, false] }],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link', 'clean']
        ]
      }
    })
    quillMountedOn = targetEl
  }
  if (bloqueEditandoId.value) {
    const bloque = bloquesActuales.value.find(b => b.id === bloqueEditandoId.value)
    quill.root.innerHTML = bloque?.params?.html ?? ''
  } else {
    quill.root.innerHTML = contenidoActual.value ?? ''
  }
}

function seleccionarComponente(id: number, nivel: 'factor' | 'caracteristica'): void {
  seleccion.value = { tipo: 'componente', id, nivel }
  if (nivel === 'factor') {
    bloqueActivo.value = subSeccionesDeFactorVisibles(id)[0]?.clave ?? 'conclusiones'
  }
  montarEditor()
}

function cambiarBloque(clave: string): void {
  bloqueActivo.value = clave
  montarEditor()
}

// Guardar
async function guardar(): Promise<void> {
  const s = seleccion.value
  if (!s || !informe.value || !quill) return
  guardando.value = true
  const html = quill.root.innerHTML === '<p><br></p>' ? null : quill.root.innerHTML

  if (bloqueEditandoId.value) {
    const idx = bloquesActuales.value.findIndex(b => b.id === bloqueEditandoId.value)
    if (idx >= 0) {
      bloquesActuales.value[idx] = {
        ...bloquesActuales.value[idx],
        params: { ...bloquesActuales.value[idx].params, html: html ?? '' }
      }
      guardarBloques()
      toast('Guardado')
    }
    guardando.value = false
    return
  }

  if (s.tipo === 'libre') {
    setTextoLibre(s.id, html)
    toast('Guardado')
    guardando.value = false
    return
  }

  if (s.tipo === 'general') {
    const r = await actualizarInformeService(informe.value.id_informe, { [s.campo]: html } as Partial<Informe>)
    if (r.ok) { if (r.data) informe.value = r.data; toast('Guardado') }
    else toast(r.error ?? 'Error al guardar', 'error')
  } else if (s.tipo === 'componente') {
    const bloque = s.nivel === 'factor' ? bloqueActivo.value : 'analisis'
    if (s.nivel === 'factor' && esBloqueLibre(s.id, bloque)) {
      setTextoLibre(`comp-${s.id}-${bloque}`, html)
      toast('Guardado')
      guardando.value = false
      return
    }
    const r = await guardarRedaccionService(informe.value.id_informe, s.id, bloque, html)
    if (r.ok) {
      toast('Guardado')
      if (r.data) {
        const idx = informe.value.redacciones?.findIndex(x => x.id_redaccion === r.data!.id_redaccion) ?? -1
        if (idx >= 0 && informe.value.redacciones)
          informe.value.redacciones[idx] = { ...informe.value.redacciones[idx], ...r.data }
      }
    } else {
      toast(r.error ?? 'Error al guardar', 'error')
    }
  }
  guardando.value = false
}

// Acciones de informe 
async function generar(): Promise<void> {
  if (!tipoSeleccionado.value) return
  generando.value = true
  const r = await generarInformeService(idEjecucion, tipoSeleccionado.value)
  if (r.ok) await cargarInforme()
  else toast(r.error ?? 'No se pudo generar el informe', 'error')
  generando.value = false
}

async function avalar(): Promise<void> {
  if (!informe.value) return
  avalando.value = true
  const r = await avalarInformeService(informe.value.id_informe)
  if (r.ok) { await cargarInforme(); toast('Informe avalado correctamente') }
  else toast(r.error ?? 'No se pudo avalar', 'error')
  avalando.value = false
}

function descargarWord(): void {
  wordAlAbrir.value = true
  mostrarPreview.value = true
}

function descargarPdf(): void {
  imprimirAlAbrir.value = true
  mostrarPreview.value = true
}

async function cargarInforme(): Promise<void> {
  const r = await getInformeService(idEjecucion)
  if (r.ok && r.data) { informe.value = r.data; cargarEstructura() }
}

// Gestión de bloques (servidor + localStorage como respaldo)

function seccionKeyActual(): string | null {
  const s = seleccion.value
  if (!s) return null
  if (s.tipo === 'general') return `gen-${s.campo}`
  if (s.tipo === 'libre') return s.id
  if (s.nivel === 'factor') return `comp-${s.id}-${bloqueActivo.value}`
  return `comp-${s.id}-analisis`
}

function storageKey(skey: string): string {
  return `informe-bloques-${informe.value!.id_informe}-${skey}`
}

async function guardarBloquesEnServidor(): Promise<void> {
  if (!informe.value) return
  const s = seleccion.value
  if (!s) return
  const json = bloquesActuales.value.length > 0
    ? JSON.stringify(bloquesActuales.value)
    : null

  if (s.tipo === 'componente') {
    return
  } else {
    const clave = s.tipo === 'general' ? (s as any).campo : (s as any).id
    const secIdx = (informe.value.secciones ?? []).findIndex(sec => sec.clave === clave)
    if (secIdx < 0) return
    const secciones = informe.value.secciones.map((sec, i) =>
      i === secIdx ? { ...sec, contenido: json } : sec
    )
    const r = await actualizarInformeService(
      informe.value.id_informe, { secciones } as Partial<Informe>
    )
    if (r.ok && r.data) informe.value = r.data
  }
}

function recargarBloques(): void {
  const key = seccionKeyActual()
  if (!key || !informe.value) { bloquesActuales.value = []; return }
  const s = seleccion.value
  if (!s) { bloquesActuales.value = []; return }

  // Primero: datos del servidor (ya cargados en informe.value)
  let serverJson: string | null | undefined = null
  if (s.tipo === 'componente') {
    const bloqueBase = s.nivel === 'factor' ? bloqueActivo.value : 'analisis'
    serverJson = informe.value.redacciones?.find(
      r => r.id_componente === s.id && r.bloque === bloqueBase + '_bloques'
    )?.contenido
  } else {
    const clave = s.tipo === 'general' ? (s as any).campo : (s as any).id
    serverJson = (informe.value.secciones ?? []).find(sec => sec.clave === clave)?.contenido
  }

  if (serverJson) {
    try { bloquesActuales.value = JSON.parse(serverJson); return } catch { /* continuar */ }
  }

  // Respaldo: localStorage
  try {
    const raw = localStorage.getItem(storageKey(key))
    bloquesActuales.value = raw ? JSON.parse(raw) : []
  } catch { bloquesActuales.value = [] }
}

function guardarBloques(): void {
  const key = seccionKeyActual()
  if (!key || !informe.value) return
  localStorage.setItem(storageKey(key), JSON.stringify(bloquesActuales.value))
  guardarBloquesEnServidor().catch(() => toast('No se pudieron guardar los bloques', 'error'))
}

function agregarBloque(b: { tipo: string; params?: Record<string, any> }): void {
  const params = b.tipo === 'COMPARATIVO'
    ? { ...b.params, id_ejecucion: idEjecucion }
    : b.params
  const nuevoId = crypto.randomUUID()
  bloquesActuales.value.push({ id: nuevoId, tipo: b.tipo, params })
  guardarBloques()
  mostrarCatalogo.value = false
  if (b.tipo === 'TEXTO') nextTick(() => editarBloqueTexto(nuevoId))
}

function actualizarParams(payload: { id: string; params: Record<string, any> }): void {
  const idx = bloquesActuales.value.findIndex(b => b.id === payload.id)
  if (idx >= 0) bloquesActuales.value[idx] = { ...bloquesActuales.value[idx], params: payload.params }
  guardarBloques()
  bloqueConfigurando.value = null
}

function actualizarVistaComparativo(id: string, vista: 'tabla' | 'grafico'): void {
  const idx = bloquesActuales.value.findIndex(b => b.id === id)
  if (idx >= 0) {
    bloquesActuales.value[idx] = {
      ...bloquesActuales.value[idx],
      params: { ...bloquesActuales.value[idx].params, vista }
    }
    guardarBloques()
  }
}

function eliminarBloque(id: string): void {
  bloquesActuales.value = bloquesActuales.value.filter(b => b.id !== id)
  guardarBloques()
}

function moverBloque(idx: number, dir: -1 | 1): void {
  const arr = [...bloquesActuales.value]
  const nIdx = idx + dir
  if (nIdx < 0 || nIdx >= arr.length) return
  ;[arr[idx], arr[nIdx]] = [arr[nIdx], arr[idx]]
  bloquesActuales.value = arr
  guardarBloques()
}

function editarBloqueTexto(id: string): void {
  bloqueEditandoId.value = id
  montarEditor()
}

function cancelarEdicionBloque(): void {
  bloqueEditandoId.value = null
  montarEditor()
}

function eliminarBloqueConReset(id: string): void {
  if (bloqueEditandoId.value === id) {
    bloqueEditandoId.value = null
    nextTick(() => montarEditor())
  }
  eliminarBloque(id)
}

watch([seleccion, bloqueActivo], () => {
  bloqueEditandoId.value = null
  recargarBloques()
})

// Montaje 

onMounted(async () => {
  const [rTipos, rInforme, , proceso, tiposEjecucion] = await Promise.all([
    getTiposInformeService(),
    getInformeService(idEjecucion),
    resultadosStore.cargar(idEjecucion),
    getProcesoByIdService(idEjecucion),
    getTiposEjecucionModeloService()
  ])
  nombreVersion.value = (proceso as any)?.version?.nombre ?? ''
  if (rTipos.ok && rTipos.data)     tipos.value   = rTipos.data
  if (rInforme.ok && rInforme.data) { informe.value = rInforme.data; cargarEstructura() }
  if (!informe.value && tipos.value.length && proceso) {
    const norm = (s: string) =>
      s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[-_\s]/g, '').toLowerCase()
    const tipoStr = proceso.tipoProceso?.tipo
      ?? tiposEjecucion.find((t: any) => t.id_tipo_ejecucion_modelo === proceso.id_tipo_ejecucion_modelo)?.tipo
    if (tipoStr) {
      const key = norm(tipoStr)
      const match = tipos.value.find(t => norm(t.nombre) === key || norm(t.etiqueta) === key)
      if (match) {
        tipoSeleccionado.value = match.id_tipo_informe
        tipoAutoDetectado.value = true
      }
    }
  }
    if (resultadosStore.resultados) {
    factores.value = (resultadosStore.resultados.factores ?? []).map((f: any) => ({
      id:     f.id_componente,
      nombre: f.nombre,
      hijos:  (f.hijos ?? []).map((c: any) => ({ id: c.id_componente, nombre: c.nombre }))
    }))
  }
  cargando.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _cache[13] || (_cache[13] = _createElementVNode("h1", null, "Informe de autoevaluación", -1)),
          (nombreVersion.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(nombreVersion.value), 1))
            : _createCommentVNode("", true),
          (informe.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(informe.value.titulo), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          class: "btn salir",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ProcesoAutoevaluacionUsuario' })))
        }, "Volver")
      ]),
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "divider" }, null, -1)),
      (cargando.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "Cargando informe…"))
        : (!informe.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", _hoisted_7, _toDisplayString(tipoAutoDetectado.value
          ? 'Tipo de informe detectado según el proceso. Genere la estructura para continuar.'
          : 'Esta ejecución aún no tiene informe. Seleccione el tipo para generar su estructura:'), 1),
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tipos.value, (t) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: t.id_tipo_informe,
                    class: _normalizeClass(["tipo-card", {
            activo: tipoSeleccionado.value === t.id_tipo_informe,
            'tipo-card--oculto': tipoAutoDetectado.value && tipoSeleccionado.value !== t.id_tipo_informe
          }])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tipoSeleccionado).value = $event)),
                      type: "radio",
                      value: t.id_tipo_informe,
                      disabled: tipoAutoDetectado.value
                    }, null, 8, _hoisted_9), [
                      [_vModelRadio, tipoSeleccionado.value]
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(t.etiqueta), 1),
                      _createElementVNode("span", _hoisted_11, "Estructura " + _toDisplayString(t.estructura) + " · " + _toDisplayString(t.secciones_default.length) + " secciones", 1)
                    ])
                  ], 2))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  class: "btn guardar",
                  disabled: !tipoSeleccionado.value || generando.value,
                  onClick: generar
                }, _toDisplayString(generando.value ? 'Generando…' : 'Generar estructura del informe'), 9, _hoisted_13)
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge-estado", informe.value.estado])
                  }, _toDisplayString(etiquetaEstado.value), 3),
                  _createElementVNode("span", _hoisted_16, [
                    _cache[14] || (_cache[14] = _createTextVNode(" Redacción: ")),
                    _createElementVNode("strong", null, _toDisplayString(redactados.value) + "/" + _toDisplayString(obligatorios.value), 1),
                    _cache[15] || (_cache[15] = _createTextVNode(" bloques obligatorios "))
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("button", {
                    class: "btn btn-toggle-arbol",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (arbolVisible.value = !arbolVisible.value))
                  }, _toDisplayString(arbolVisible.value ? '◀ Ocultar menú' : '▶ Mostrar menú'), 1),
                  _createElementVNode("button", {
                    class: "btn accion",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (mostrarPreview.value = true))
                  }, "Ver informe"),
                  _createElementVNode("button", {
                    class: "btn salir",
                    onClick: descargarWord
                  }, "Descargar Word"),
                  _createElementVNode("button", {
                    class: "btn salir",
                    onClick: descargarPdf
                  }, "Descargar PDF"),
                  (!avalado.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn guardar",
                        disabled: redactados.value < obligatorios.value || avalando.value,
                        onClick: avalar
                      }, _toDisplayString(avalando.value ? 'Avalando…' : 'Avalar informe'), 9, _hoisted_18))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["panel-doble", { 'panel-sin-arbol': !arbolVisible.value }])
              }, [
                (arbolVisible.value)
                  ? (_openBlock(), _createElementBlock("aside", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "arbol-head-label" }, "Secciones", -1)),
                        _createElementVNode("button", {
                          class: _normalizeClass(["btn-modo-edicion", { activo: modoEdicionArbol.value }]),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (modoEdicionArbol.value = !modoEdicionArbol.value))
                        }, _toDisplayString(modoEdicionArbol.value ? 'Listo' : 'Editar'), 3)
                      ]),
                      (!modoEdicionArbol.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(seccionesVisibles.value, (s) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: s.id,
                                class: _normalizeClass(["nodo", [s.tipo === 'libre' ? 'libre' : 'general', { activo: esSeccionActiva(s) }]]),
                                onClick: ($event: any) => (seleccionarSeccion(s))
                              }, [
                                _createElementVNode("span", _hoisted_22, _toDisplayString(tieneContenidoSeccion(s) ? '✓' : '○'), 1),
                                _createTextVNode(" " + _toDisplayString(s.titulo), 1)
                              ], 10, _hoisted_21))
                            }), 128)),
                            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "arbol-separador" }, "Factores y características", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factores.value, (f) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: f.id
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["nodo factor", { activo: seleccion.value?.tipo === 'componente' && seleccion.value.id === f.id && seleccion.value.nivel === 'factor' }]),
                                  onClick: ($event: any) => (seleccionarComponente(f.id, 'factor'))
                                }, [
                                  _createElementVNode("span", _hoisted_24, _toDisplayString(factorCompleto(f.id) ? '✓' : '○'), 1),
                                  _createTextVNode(" " + _toDisplayString(f.nombre), 1)
                                ], 10, _hoisted_23),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(f.hijos, (c) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: c.id,
                                    class: _normalizeClass(["nodo caracteristica", { activo: seleccion.value?.tipo === 'componente' && seleccion.value.id === c.id }]),
                                    onClick: ($event: any) => (seleccionarComponente(c.id, 'caracteristica'))
                                  }, [
                                    _createElementVNode("span", _hoisted_26, _toDisplayString(redaccion(c.id, 'analisis')?.contenido ? '✓' : '○'), 1),
                                    _createTextVNode(" " + _toDisplayString(c.nombre), 1)
                                  ], 10, _hoisted_25))
                                }), 128))
                              ], 64))
                            }), 128))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "edit-grupo-label" }, "Secciones del informe", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(estructura.value.secciones, (s, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: s.id,
                                class: _normalizeClass(["edit-item", { oculta: !s.visible }])
                              }, [
                                _createElementVNode("button", {
                                  class: _normalizeClass(["edit-toggle", { visible: s.visible }]),
                                  onClick: ($event: any) => (toggleVisibilidadSeccion(s.id))
                                }, _toDisplayString(s.visible ? 'Visible' : 'Oculta'), 11, _hoisted_27),
                                _createElementVNode("span", _hoisted_28, _toDisplayString(s.titulo), 1),
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("button", {
                                    class: "btn-ctrl",
                                    disabled: idx === 0,
                                    onClick: ($event: any) => (moverSeccion(s.id, -1))
                                  }, "▲", 8, _hoisted_30),
                                  _createElementVNode("button", {
                                    class: "btn-ctrl",
                                    disabled: idx === estructura.value.secciones.length - 1,
                                    onClick: ($event: any) => (moverSeccion(s.id, 1))
                                  }, "▼", 8, _hoisted_31),
                                  (s.tipo === 'libre')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn-ctrl eliminar",
                                        onClick: ($event: any) => (eliminarSeccionLibre(s.id))
                                      }, "✕", 8, _hoisted_32))
                                    : _createCommentVNode("", true)
                                ])
                              ], 2))
                            }), 128)),
                            _createElementVNode("div", _hoisted_33, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((nuevaSeccionTitulo).value = $event)),
                                class: "form-control-mini",
                                placeholder: "Nueva sección…",
                                onKeyup: _withKeys(agregarSeccionLibre, ["enter"])
                              }, null, 544), [
                                [_vModelText, nuevaSeccionTitulo.value]
                              ]),
                              _createElementVNode("button", {
                                class: "btn-add-sec",
                                disabled: !nuevaSeccionTitulo.value.trim(),
                                onClick: agregarSeccionLibre
                              }, " Añadir ", 8, _hoisted_34)
                            ]),
                            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "arbol-separador" }, "Factores y características", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factores.value, (f) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: f.id
                              }, [
                                _createElementVNode("div", _hoisted_35, _toDisplayString(f.nombre), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subSeccionesDeFactorTodas(f.id), (sub, sidx) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: sub.clave,
                                    class: _normalizeClass(["edit-item sub", { oculta: !sub.visible }])
                                  }, [
                                    _createElementVNode("button", {
                                      class: _normalizeClass(["edit-toggle", { visible: sub.visible }]),
                                      onClick: ($event: any) => (toggleVisibilidadSubSeccion(f.id, sub.clave))
                                    }, _toDisplayString(sub.visible ? 'Visible' : 'Oculta'), 11, _hoisted_36),
                                    _createElementVNode("span", _hoisted_37, _toDisplayString(sub.titulo), 1),
                                    _createElementVNode("div", _hoisted_38, [
                                      _createElementVNode("button", {
                                        class: "btn-ctrl",
                                        disabled: sidx === 0,
                                        onClick: ($event: any) => (moverSubSeccion(f.id, sub.clave, -1))
                                      }, "▲", 8, _hoisted_39),
                                      _createElementVNode("button", {
                                        class: "btn-ctrl",
                                        disabled: sidx === subSeccionesDeFactorTodas(f.id).length - 1,
                                        onClick: ($event: any) => (moverSubSeccion(f.id, sub.clave, 1))
                                      }, "▼", 8, _hoisted_40),
                                      (sub.libre)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn-ctrl eliminar",
                                            onClick: ($event: any) => (eliminarSubSeccionLibre(f.id, sub.clave))
                                          }, "✕", 8, _hoisted_41))
                                        : _createCommentVNode("", true)
                                    ])
                                  ], 2))
                                }), 128)),
                                (factorEditandoId.value === f.id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((nuevaSubSeccionTitulo).value = $event)),
                                        class: "form-control-mini",
                                        placeholder: "Nombre de sub-sección…",
                                        onKeyup: _withKeys(($event: any) => (agregarSubSeccionLibre(f.id)), ["enter"])
                                      }, null, 40, _hoisted_43), [
                                        [_vModelText, nuevaSubSeccionTitulo.value]
                                      ]),
                                      _createElementVNode("button", {
                                        class: "btn-add-sec",
                                        disabled: !nuevaSubSeccionTitulo.value.trim(),
                                        onClick: ($event: any) => (agregarSubSeccionLibre(f.id))
                                      }, "Añadir", 8, _hoisted_44),
                                      _createElementVNode("button", {
                                        class: "btn-cancel",
                                        onClick: _cache[7] || (_cache[7] = ($event: any) => (factorEditandoId.value = null))
                                      }, "Cancelar")
                                    ]))
                                  : (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      class: "btn-add-subsec",
                                      onClick: ($event: any) => {factorEditandoId.value = f.id; nuevaSubSeccionTitulo.value = ''}
                                    }, "+ Sub-sección", 8, _hoisted_45))
                              ], 64))
                            }), 128))
                          ], 64))
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_46, [
                  (seleccion.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (seleccion.value.tipo === 'componente' && seleccion.value.nivel === 'factor')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subSeccionesDeFactorVisibles(seleccion.value.id), (sub) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: sub.clave,
                                  class: _normalizeClass(["tab", { activo: bloqueActivo.value === sub.clave }]),
                                  onClick: ($event: any) => (cambiarBloque(sub.clave))
                                }, _toDisplayString(sub.titulo), 11, _hoisted_48))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (contexto.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(contexto.value), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "bloques-label" }, "Bloques de datos", -1)),
                            (!avalado.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn-insertar",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (mostrarCatalogo.value = true))
                                }, " + Insertar "))
                              : _createCommentVNode("", true)
                          ]),
                          (bloquesActuales.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bloquesActuales.value, (b, idx) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: b.id,
                                    class: _normalizeClass(["bloque-item", { 'bloque-editando': bloqueEditandoId.value === b.id }])
                                  }, [
                                    _createElementVNode("div", _hoisted_53, [
                                      _createElementVNode("span", _hoisted_54, _toDisplayString(b.tipo === 'TEXTO' ? 'Texto libre' : b.tipo.replace(/_/g, ' ')), 1),
                                      _createElementVNode("div", _hoisted_55, [
                                        _createElementVNode("button", {
                                          class: "btn-ctrl",
                                          disabled: idx === 0,
                                          onClick: ($event: any) => (moverBloque(idx, -1))
                                        }, "▲", 8, _hoisted_56),
                                        _createElementVNode("button", {
                                          class: "btn-ctrl",
                                          disabled: idx === bloquesActuales.value.length - 1,
                                          onClick: ($event: any) => (moverBloque(idx, 1))
                                        }, "▼", 8, _hoisted_57),
                                        (b.tipo !== 'TEXTO')
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              class: "btn-ctrl btn-ctrl--texto",
                                              onClick: ($event: any) => (toggleColapsarBloque(b.id))
                                            }, _toDisplayString(bloquesColapsados.value.includes(b.id) ? 'Mostrar' : 'Ocultar'), 9, _hoisted_58))
                                          : _createCommentVNode("", true),
                                        (b.tipo === 'TEXTO' && !avalado.value && bloqueEditandoId.value !== b.id)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 1,
                                              class: "btn-ctrl opciones",
                                              onClick: ($event: any) => (editarBloqueTexto(b.id))
                                            }, " Editar ", 8, _hoisted_59))
                                          : (b.tipo !== 'TEXTO')
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                class: "btn-ctrl opciones",
                                                onClick: ($event: any) => (bloqueConfigurando.value = b)
                                              }, "Opciones", 8, _hoisted_60))
                                            : _createCommentVNode("", true),
                                        (!avalado.value)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 3,
                                              class: "btn-ctrl eliminar",
                                              onClick: ($event: any) => (eliminarBloqueConReset(b.id))
                                            }, "✕", 8, _hoisted_61))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    (b.tipo === 'TEXTO')
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          (bloqueEditandoId.value === b.id)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                _createElementVNode("div", {
                                                  ref_for: true,
                                                  ref: (el) => { _isRef(inlineEditorEl) //@ts-ignore
 ? inlineEditorEl.value = el : inlineEditorEl = el },
                                                  class: "editor"
                                                }, null, 512),
                                                _createElementVNode("div", _hoisted_63, [
                                                  _createElementVNode("button", {
                                                    class: "btn guardar",
                                                    disabled: guardando.value,
                                                    onClick: guardar
                                                  }, _toDisplayString(guardando.value ? 'Guardando…' : 'Guardar'), 9, _hoisted_64),
                                                  _createElementVNode("button", {
                                                    class: "btn salir",
                                                    onClick: cancelarEdicionBloque
                                                  }, "Cancelar")
                                                ])
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                class: _normalizeClass(["bloque-texto-preview", { 'bloque-texto-preview--editable': !avalado.value }]),
                                                onClick: ($event: any) => (!avalado.value && editarBloqueTexto(b.id))
                                              }, [
                                                _createVNode(BloqueDatos, {
                                                  tipo: b.tipo,
                                                  params: b.params
                                                }, null, 8, ["tipo", "params"])
                                              ], 10, _hoisted_65))
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (bloquesColapsados.value.includes(b.id))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_66, " Tabla — " + _toDisplayString(b.tipo.replace(/_/g, ' ')), 1))
                                            : (_openBlock(), _createBlock(BloqueDatos, {
                                                key: 1,
                                                tipo: b.tipo,
                                                params: b.params,
                                                "onUpdate:vistaInicial": ($event: any) => (actualizarVistaComparativo(b.id, $event))
                                              }, null, 8, ["tipo", "params", "onUpdate:vistaInicial"]))
                                        ], 64))
                                  ], 2))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_67, "Sin bloques insertados en esta sección."))
                        ]),
                        (avalado.value)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "solo-lectura",
                              innerHTML: contenidoActual.value || '<p><i>Sin contenido</i></p>'
                            }, null, 8, _hoisted_68))
                          : (!bloqueEditandoId.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "editor-cabecera" }, [
                                  _createElementVNode("span", { class: "editor-contexto-label" }, "Texto de la sección")
                                ], -1)),
                                _createElementVNode("div", {
                                  ref_key: "editorEl",
                                  ref: editorEl,
                                  class: "editor"
                                }, null, 512),
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("button", {
                                    class: "btn guardar",
                                    disabled: guardando.value,
                                    onClick: guardar
                                  }, _toDisplayString(guardando.value ? 'Guardando…' : 'Guardar'), 9, _hoisted_70)
                                ])
                              ], 64))
                            : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_71, _cache[22] || (_cache[22] = [
                        _createElementVNode("p", null, "Seleccione una sección del panel izquierdo para redactar", -1)
                      ])))
                ])
              ], 2)
            ], 64))
    ]),
    _createVNode(CatalogoBloquesModal, {
      visible: mostrarCatalogo.value,
      onCerrar: _cache[9] || (_cache[9] = ($event: any) => (mostrarCatalogo.value = false)),
      onInsertar: agregarBloque
    }, null, 8, ["visible"]),
    _createVNode(ConfiguradorBloqueModal, {
      visible: !!bloqueConfigurando.value,
      bloque: bloqueConfigurando.value,
      onCerrar: _cache[10] || (_cache[10] = ($event: any) => (bloqueConfigurando.value = null)),
      onGuardar: actualizarParams
    }, null, 8, ["visible", "bloque"]),
    (mostrarPreview.value && informe.value)
      ? (_openBlock(), _createBlock(VistaPreviewInforme, {
          key: 0,
          visible: mostrarPreview.value,
          informe: informe.value!,
          factores: factores.value,
          "auto-imprimir": imprimirAlAbrir.value,
          "auto-descargar-word": wordAlAbrir.value,
          onCerrar: _cache[11] || (_cache[11] = ($event: any) => {mostrarPreview.value = false; imprimirAlAbrir.value = false; wordAlAbrir.value = false})
        }, null, 8, ["visible", "informe", "factores", "auto-imprimir", "auto-descargar-word"]))
      : _createCommentVNode("", true),
    _createVNode(MensajeFlotante, {
      visible: msj.visible,
      mensaje: msj.mensaje,
      tipo: msj.tipo,
      onCerrar: _cache[12] || (_cache[12] = ($event: any) => (msj.visible = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ], 64))
}
}

})